var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTableHeader',{staticClass:"table-header"},[_c('VGridCol',[_vm._v("№")]),_c('VGridCol',[_vm._v("Дата создания")]),_c('VGridCol',[_vm._v("Срок исполнения")]),_c('VGridCol',[_vm._v("Проект")]),_c('VGridCol',[_vm._v("Ответственный")]),_c('VGridCol',[_vm._v("Исполнитель")]),_c('VGridCol',[_vm._v("Статус заявки")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }